var _defs, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "today",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.86 29.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_today") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.72 11.45 9.13 6.86 11 4.98 0 0.03 4.93 11.05 6.93 9.05 11.53 13.64 13.72 11.45"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.45 16.09 6.86 20.68 4.98 18.81 0.03 29.81 11.05 24.87 9.05 22.87 13.64 18.28 11.45 16.09"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.14 18.06 20.73 22.66 18.86 24.53 29.86 29.49 24.92 18.47 22.92 20.47 18.33 15.87 16.14 18.06"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.31 13.72 22.9 9.13 24.78 11 29.73 0 18.71 4.93 20.71 6.93 16.12 11.53 18.31 13.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToday);
export default __webpack_public_path__ + "static/media/icon_today.3f877ed6.svg";
export { ForwardRef as ReactComponent };